const frameToString = ({ line, file, column }) => `${file}:${line}:${column}`;
const parseStackLine = (stackLine) => {
    const matches = /\s+at\s+(.+\s)?\(?(.+):(\d+):(\d+)\)?/.exec(stackLine) ||
        /(.+)@(.+):(\d+):(\d+)/g.exec(stackLine); // Safari style
    if (!matches)
        return null;
    const [, , file, line, column] = matches;
    return { file, line: parseInt(line), column: parseInt(column) };
};
const parseStackTrace = (trace, picker) => parseStackLine(picker(trace.split("\n")));
export const currentLocation = (depth) => {
    const x = parseStackTrace(new Error().stack, (x) => x[depth]);
    return x ? frameToString(x) : "stack line could not be parsed";
};
